import { createSelector } from '@ngrx/store';

export const getSearchState = createSelector(
    (state: any) => state.search,
    (state: any) => state
);
